import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AuthenticationService } from '../service/authentication.service';
import { NgForm } from '@angular/forms';
import { UtilService } from '../service/util.service';
import { Router } from '@angular/router';
import { ApiService } from '../service/api.service';
import { ToastService } from '../service/toast.service';
import { Constants } from '../constants/constants';
import { EnvService } from '../service/env.service';
import { EmailMaskPipe } from '../pipe/emailMask.pipe';
import { MessageConstants } from '../constants/message-constants';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  isShowform = false;
  loginModal;
  resetPasswordModal;
  @ViewChild('loginForm') public loginForm: NgForm;
  @ViewChild('resetPasswordForm') public resetPasswordForm: NgForm;
  authSubscription: any;
  isNewPasswordRequired: boolean = false;
  isForgotPasswordClicked: boolean = false;
  resetForgotPasswordModal;
  resetForgotPasswordCode: boolean = false;
  loginResponseData;
  confirmationCodeMessage: any = null;
  passwordRule = Constants.PASSWORD_RULE;
  passwordFormatError = Constants.PASSWORD_FORMAT_ERROR;

  smsMfaData: any;
  showSmsMfaVerification: boolean = false;
  confirmationModalAttributes: any;
  @ViewChild('resetForgotPasswordForm') resetForgotPasswordFormRef: NgForm;

  constructor(private apiService: ApiService, public authService: AuthenticationService, private router: Router, private utilService: UtilService, private toast: ToastService, private env: EnvService, private emailMaskPipe: EmailMaskPipe) {
    this.authSubscription = this.authService.authenticationState.subscribe(state => {
      // console.log("Auth Changed : ", state, " logged in user details : ", this.authService.loggedInUser);
      if (state) {
        this.isShowform = false;
        // if(!this.authService.isAdmin()) {
        if (!this.authService.isUserRoleAllowed()) {
          // this.router.navigate(["/rental-fleet"]);
          this.toast.showError("You don't have the permission to access this portal.");
          this.authService.logout();
          this.router.navigate(["/"]);
        } else {
          console.log("loginComponent - route to homepage");
          // this.routeToHomePage();
        }
      } else {
        this.isShowform = true;
        this.apiService.accountDetail = null;
      }
    });
  }

  routeToHomePage() {
    // wait for 1.2 second to execute account detail api in the header.
    setTimeout(() => {
      // var accountStatus = this.apiService.accountDetail.status;
      // if(true || accountStatus == Constants.INACTIVE || accountStatus == Constants.PENDING) {
      //   this.router.navigate(["/tnc"]);
      //   return;
      // }
      if (this.authService.isDongleProvider()) {
        this.router.navigate(["/provider/dashboard"]);
      } else {
        var accountCategory = this.apiService.accountDetail.category;
        if (accountCategory == "RENTAL_FLEET") {
          this.router.navigate(["/rental-fleet"]);
        } else if (accountCategory == "FLEET_MANAGEMENT_COMPANY") {
          this.router.navigate(["/commercial-fleet"]);
        }
      }
    }, 1200);
  }

  ngOnDestroy() {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.initLoginModal();
    this.initResetPasswordModal();
    this.initConfirmationModalAttributes();
  }

  initLoginModal() {
    this.loginModal = null;
    this.loginModal = {
      username: null,
      password: null,
      appName: this.env.PORTAL_APP_TYPE.get(this.env.MODE)
    };
  }

  initResetPasswordModal() {
    this.resetPasswordModal = null;
    this.resetPasswordModal = {
      password: null,
      confirmPassword: null
    }
  }

  loginFormSubmit(form: NgForm) {
    this.loginForm = form;
    if (form.valid) {
      // console.log("login : ", this.loginModal);
      this.utilService.showSpinner();
      this.authService.login(this.loginModal).then((data) => {
        this.utilService.hideSpinner();
        // console.log("login response data::", data);
        this.loginResponseData = data;
        this.processChallenge(data);
        this.resetLoginForm();
        
        //TODO: Test code remove later
        // this.utilService.setCurrency("Spain");
        // this.utilService.setCountryDateFormat("Spain");
      }).catch((error) => {
        this.utilService.hideSpinner();
        this.toast.showError(this.utilService.getErrorMessage(error.error.message));
      });
    }
  }

  processChallenge(data) {
    if (!data["challengeName"]) return;

    if (data["challengeName"] == Constants.NEW_PASSWORD_REQUIRED) {
      console.log("New Password Required");
      this.isNewPasswordRequired = true;
    } else if (data["challengeName"] == Constants.SMS_MFA) {
      this.showSmsMfaVerification = true;
      this.smsMfaData = data;
    } else if (data["challengeName"] == Constants.RESET_PASSWORD_REQUIRED) {
      this.initResetForgotPasswordModal();
      this.resetForgotPasswordCode = true;
      this.resetForgotPasswordModal['username'] = data['username'];
      if (data.username) {
        this.confirmationCodeMessage = MessageConstants.CONFRIMATION_CODE_MESSAGE.replace("maskedEmail", this.emailMaskPipe.transform(data.username));
      }
    } else if (data["challengeName"] == Constants.CUSTOM_CHALLENGE) {
      this.showSmsMfaVerification = true;
      this.smsMfaData = data;
    } else {
      console.log("Unexpected Challange name : ", data);
    }
  }

  resetPasswordSubmit(resetPasswordForm: NgForm) {
    this.resetPasswordForm = resetPasswordForm;
    if (resetPasswordForm.valid) {
      // console.log("reset password data::", this.resetPasswordModal);
      if (this.resetPasswordModal.password != this.resetPasswordModal.confirmPassword) {
        this.toast.showError("Password and Confirm Password do not match.");
        return;
      }
      var payload = {
        "confirmPassword": this.resetPasswordModal.confirmPassword,
        "password": this.resetPasswordModal.password,
        "session": this.loginResponseData["session"],
        "username": this.loginResponseData["username"]
      }
      // console.log("reset password payload::", payload);
      this.utilService.showSpinner();
      this.authService.resetPassword(payload).then((data) => {
        this.utilService.hideSpinner();
        this.resetResetPasswordForm();
        this.processChallenge(data);
      }).catch((error) => {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.errorCode == Constants.AUTH_401102) {
          this.toast.showError(Constants.LOGIN_SESSION_EXPIRED);
        } else {
          this.toast.showError(error && error.error && error.error.message ? error.error.message : Constants.UNKNOWN_ERROR);
        }
        setTimeout(() => {
          if (error.error.status && error.error.status == Constants.HTTP_BAD_REQUEST) {
            if (error.error.message && error.error.message == Constants.SESSION_TIMEOUT_MESSAGE) {
              this.isNewPasswordRequired = false;
            }
          }
        }, 1000);
      });
    }

  }

  resetLoginForm() {
    if (this.loginForm) {
      this.loginForm.reset();
      this.loginForm.resetForm();
      this.initLoginModal();
    }
  }

  resetResetPasswordForm() {
    if (this.resetPasswordForm) {
      this.resetPasswordForm.reset();
      this.resetPasswordForm.resetForm();
      this.initResetPasswordModal();
      this.isNewPasswordRequired = false;
    }
  }

  forgotPasswordClicked() {
    console.log("Forgot password clicked");
    this.isForgotPasswordClicked = true;
    // this.initResetForgotPasswordModal();
  }

  forgotPasswordSubmit(form: NgForm) {

    if (form.valid) {
      var forgotPasswordRequest = {
        "username": form['username'],
        "appName": this.env.PORTAL_APP_TYPE.get(this.env.MODE)
      };

      this.initResetForgotPasswordModal();
      this.resetForgotPasswordModal.username = form['username'];
      console.log("Forgot password request : ", forgotPasswordRequest);
      this.getConfirmationCode(forgotPasswordRequest);

    }
  }

  getConfirmationCode(payload) {
    this.utilService.showSpinner();
    this.authService.forgotPassword(payload).then((data) => {
      this.utilService.hideSpinner();
      this.confirmationCodeMessage = MessageConstants.CONFRIMATION_CODE_MESSAGE.replace("maskedEmail", this.emailMaskPipe.transform(payload.username));
      this.toast.showSuccess(data['message']);
      this.resetForgotPasswordForm();
    }).catch((error) => {
      this.utilService.hideSpinner();
      this.toast.showError(error.error.message);
    });
  }

  resetForgotPasswordSubmit(resetForgotPasswordForm: NgForm) {
    // this.resetForgotPasswordModal.username = this.loginResponseData['username'];
    console.log("Reset password data :  ", this.resetForgotPasswordModal);

    if (resetForgotPasswordForm.valid) {

      if (this.resetForgotPasswordModal.password != this.resetForgotPasswordModal.confirmPassword) {
        this.toast.showError("Password and Confirm Password do not match.");
        return;
      }

      this.utilService.showSpinner();
      this.authService.confirmForgotPassword(this.resetForgotPasswordModal).then((data) => {
        this.utilService.hideSpinner();
        this.toast.showSuccess("Password updated successfully");
        this.resetForgotPasswordFlow();
      }).catch((error) => {
        this.utilService.hideSpinner();
        this.toast.showError(error.error.message);
        setTimeout(() => {
          if (error.error.status && error.error.status == Constants.HTTP_BAD_REQUEST) {
            if (error.error.message && error.error.message == Constants.SESSION_TIMEOUT_MESSAGE) {
              this.resetForgotPasswordFlow();
            }
          }
        }, 1000);
      });
    }
  }

  initResetForgotPasswordModal() {
    // this.resetForgotPasswordModal = null;
    this.resetForgotPasswordModal = {
      code: null,
      username: null,
      password: null,
      confirmPassword: null
    }
  }

  resetForgotPasswordForm() {

    this.resetForgotPasswordCode = true;
    this.isForgotPasswordClicked = false;

  }

  resetForgotPasswordFlow() {

    this.initResetForgotPasswordModal();
    this.isNewPasswordRequired = false;
    this.resetForgotPasswordCode = false;
    this.isForgotPasswordClicked = false;

  }

  resetUpdatePassword() {
    this.initResetPasswordModal();
    this.isNewPasswordRequired = false;
    this.resetForgotPasswordCode = false;
    this.isForgotPasswordClicked = false;
  }

  resendConfirmationCode() {
    var paylaod = {
      "username": this.resetForgotPasswordModal.username
    };
    console.log("Resend code : ", paylaod);
    this.getConfirmationCode(paylaod);
  }

  resendMfaError(error) {
    this.showSmsMfaVerification = false;
  }

  onCancelResetForgotPasswordForm() {
    if (this.resetForgotPasswordFormRef.dirty) {
      document.getElementById(this.confirmationModalAttributes.modalOpenButtonId).click();
    } else {
      this.resetForgotPasswordFlow();
    }
  }
  
  onConfirm(data?) {
    this.resetForgotPasswordFlow();
    document.getElementById(this.confirmationModalAttributes.modalCloseButtonId).click();
  }
  
  onConfirmCancel(data?) {
    document.getElementById(this.confirmationModalAttributes.modalCloseButtonId).click();
  }

  initConfirmationModalAttributes() {
    this.confirmationModalAttributes = {
      "modalId": "forgotPasswordFormConfirmationModal",
      "modalOpenButtonId": "openForgotPasswordFormConfirmationModal",
      "modalCloseButtonId": "closeForgotPasswordFormConfirmationModal",
      "modalHeader": "Close Reset Password Form",
      "content": "You are about to close the form without saving.\nAre you sure you want to proceed?",
      "submitButtonClass": "btn btn-primary btn-80",
      "cancelButtonClass": "btn btn-light btn-80"
    }
  }
}
